import { WraV0Row } from './models/wra-v0-row';
import { WraValue } from '../v0/models/wraValue';
import { WraV0GlobalMeasureCheckValue } from './models/wra-v0-global-measure-check-value';
import { WraV0MeasureCategory } from './models/wra-v0-measure-category';
import { WRAValueAnswer } from '../v0/models/wraValueAnswer';
import { WProperties, WRiskAssessmentProperties } from '@pt/pt-models';

export class WraV0Utils {

  public static toWraV0Rows(
    widgetProperties: WProperties,
    widgetValue?: WraValue,
    measureCategory?: WraV0MeasureCategory[],
    queryGlobalMeasureCheckValue?: WraV0GlobalMeasureCheckValue[]): WraV0Row[] {

    const response: WraV0Row[] = [];
    if (widgetValue && measureCategory && widgetProperties) {
      switch (widgetProperties.riskAssessmentViewMode) {
        case WRiskAssessmentProperties.FILL_FROM_TRIGGER_AND_SELECT:
          measureCategory.forEach((mc: WraV0MeasureCategory) => {
            // filtro solo le misure presenti nel value del widget
            const widgetValueAnswer: WRAValueAnswer | undefined = widgetValue?.answers?.find((a) => a.uuid === mc.uuid);
            if (widgetValueAnswer) {
              const queryValue: WraV0GlobalMeasureCheckValue = queryGlobalMeasureCheckValue.find((item) => item.uuid === mc.uuid);
              response.push(WraV0Utils.generateWraV0Row(widgetValueAnswer, mc, queryValue))
            }
          })
          break;
        case WRiskAssessmentProperties.FILL_FROM_TRIGGER:
          measureCategory.forEach((mc: WraV0MeasureCategory) => {
            // filtro solo le misure presenti nel value del widget
            const widgetValueAnswer: WRAValueAnswer | undefined  = widgetValue?.answers?.find((a) => a.uuid === mc.uuid);
            if (widgetValueAnswer) {
              response.push(WraV0Utils.generateWraV0Row(widgetValueAnswer, mc, undefined))
            }
          })
          break;
        case WRiskAssessmentProperties.FILL_FROM_QUERY:
        default:
          measureCategory.forEach((mc: WraV0MeasureCategory) => {
            // filtro solo le misure presenti nel value del widget
            const widgetValueAnswer: WRAValueAnswer | undefined  = widgetValue?.answers?.find((a) => a.uuid === mc.uuid);
            if (widgetValueAnswer) {
              response.push(WraV0Utils.generateWraV0Row(widgetValueAnswer, mc, undefined))
            } else {
              response.push({
                measureCategory: mc,
                widgetValue: {
                  uuid: mc.uuid,
                  note: undefined,
                  implementedValue: undefined
                },
                globalMeasureCheckValue: undefined
              })
            }
          })
      }
    }
    return response;
  }

  private static generateWraV0Row(widgetValueAnswer: WRAValueAnswer, measureCategory: WraV0MeasureCategory, queryValue?: WraV0GlobalMeasureCheckValue): WraV0Row {
    const response: WraV0Row = {
      measureCategory,
      widgetValue: {
        uuid: widgetValueAnswer.uuid,
        note: widgetValueAnswer.note,
        implementedValue: widgetValueAnswer.implementedValue,
      },
      globalMeasureCheckValue: queryValue
    }
    return response;
  }
}
